var chunkMapping = {
	"860": [
		20124,
		62797,
		88296,
		93947
	],
	"5228": [
		75228
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	],
	"8186": [
		99406
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		31999
	],
	"7293": [
		"default",
		"./AppLoader",
		31999
	],
	"17418": [
		"default",
		"./appSlice",
		31999
	],
	"20124": [
		"default",
		"./components/NotificationBell",
		31999
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		31999
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		31999
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		31999
	],
	"49394": [
		"default",
		"./store",
		31999
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		31999
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		31999
	],
	"75228": [
		"default",
		"./utils/constants",
		31999
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		31999
	],
	"85646": [
		"default",
		"./headerSlice",
		31999
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		31999
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		31999
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		31999
	],
	"99406": [
		"default",
		"./providers/FlagsmithProvider",
		31999
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"20124": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	],
	"99406": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 31999
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}